import styled from "styled-components";

export const ChatContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background: #f0f2f5;
  overflow: hidden;
  position: relative;

  .ps__rail-x {
    display: none;
  }
  
  .scrollbar-container {
    height: calc(100vh - 140px);
  }

  /* Quando está no main-container com chat-fullscreen */
  .main-container.chat-fullscreen & {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 768px) {
    background: #ffffff;
    height: 100vh;
    padding: 0;

    .scrollbar-container {
      height: calc(100vh - 140px);
    }

    #root > #chat-wrapper ~ .bottom-navigation {
      display: none;
    }
  }
  
  @media only screen and (min-width: 1279px) and (min-height: 800px) {
    .scrollbar-container {
      height: calc(100vh - 140px);
    }
  }
`;

export const ContainerDisconnectedChat = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #f0f2f5, #e8eaed);
`;

export const DisconnectedIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
  opacity: 0.7;
`;

export const DisconnectedTitle = styled.h3`
  color: #3c4043;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
  text-align: center;
`;

export const DisconnectedText = styled.p`
  color: #5f6368;
  font-size: 16px;
  text-align: center;
  line-height: 1.5;
  max-width: 400px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #54656f;
`;

export const LoadingText = styled.p`
  margin-top: 16px;
  font-size: 14px;
  color: #54656f;
`;

export const LoadingMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  color: #54656f;
  font-size: 14px;
`;

export const Sidebar = styled.div`
  width: 30%;
  min-width: 320px;
  max-width: 420px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-right: 1px solid #e9edef;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    box-shadow: none;
    height: 100vh;
  }
`;

export const SidebarHeader = styled.div`
  padding: 8px 20px;
  background: var(--primary);
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.2);
`;

export const UserAvatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  object-fit: cover;
  border: 2px solid var(--primary);
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(48, 92, 222, 0.6);
    transform: scale(1.05);
  }
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 8px 16px;
  flex: 1;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;

  &:focus-within {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: scale(1.02);
  }
`;

export const SearchIcon = styled.div`
  color: rgba(255, 255, 255, 0.8);
  margin-right: 10px;
  font-size: 14px;
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  color: white;
  font-size: 14px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
`;

export const ConversationList = styled.div`
  flex: 1;
  overflow: hidden;
  background: #ffffff;
  height: calc(100vh - 140px);
`;

export const ConversationItem = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  background: ${(props) =>
    props.active ? "linear-gradient(135deg, #e8f5e8, #f0f8ff)" : "transparent"};
  border-bottom: 1px solid #f0f2f5;
  transition: all 0.3s ease;
  position: relative;

  ${(props) =>
    props.active &&
    `
    border-left: 4px solid var(--primary);
    box-shadow: inset 0 0 0 1px rgba(48, 92, 222, 0.1);
  `}

  &:hover {
    background: ${(props) =>
      props.active ? "linear-gradient(135deg, #e8f5e8, #f0f8ff)" : "#f8f9fa"};
    transform: translateX(2px);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const Avatar = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  margin-right: 16px;
  object-fit: cover;
  border: 2px solid #f0f2f5;
  transition: all 0.3s ease;

  ${ConversationItem}:hover & {
    border-color: var(--primary);
    transform: scale(1.05);
  }
`;

export const ConversationDetails = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 65%;
  }
`;

export const ConversationName = styled.div`
  font-weight: ${(props) => (props.hasUnread ? "700" : "600")};
  color: #111b21;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;

  ${(props) =>
    props.hasUnread &&
    `
    color: #25d366;
  `}
`;

export const LastMessage = styled.div`
  font-size: 14px;
  color: #667781;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
`;

export const ConversationMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

export const MessageTime = styled.div`
  font-size: 12px;
  color: #667781;
  font-weight: 500;
`;

export const UnreadBadge = styled.div`
  background: linear-gradient(135deg, #25d366, #128c7e);
  color: white;
  border-radius: 12px;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  padding: 0 6px;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const ChatWindow = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
  }
`;

export const ChatHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 1px solid #e9edef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 10;
  backdrop-filter: blur(10px);
  height: 68px; /* Altura fixa para cálculos */
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 12px 15px;
    height: 64px;
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #54656f;
  cursor: pointer;
  font-size: 18px;
  margin-right: 12px;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f2f5;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const ChatAvatar = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-right: 16px;
  object-fit: cover;
  border: 2px solid #e9edef;
  transition: all 0.3s ease;

  &:hover {
    border-color: #25d366;
    transform: scale(1.05);
  }
`;

export const ChatHeaderDetails = styled.div`
  flex: 1;
`;

export const ChatName = styled.div`
  font-weight: 600;
  color: #111b21;
  text-transform: capitalize;
  font-size: 16px;
  margin-bottom: 2px;
`;

export const ChatStatus = styled.div`
  font-size: 13px;
  color: #667781;
`;

export const StatusIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => {
    switch (props.status) {
      case "active":
        return "#25d366";
      case "paused":
        return "#ffa726";
      case "disabled":
        return "#ef5350";
      default:
        return "#667781";
    }
  }};
`;

export const StatusDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => {
    switch (props.status) {
      case "active":
        return "#25d366";
      case "paused":
        return "#ffa726";
      case "disabled":
        return "#ef5350";
      default:
        return "#667781";
    }
  }};
  animation: ${(props) =>
    props.status === "active" ? "pulse 2s infinite" : "none"};

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const MessagesContainer = styled.div`
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  background: linear-gradient(135deg, #e5ddd5, #f0f2f5);
  position: relative;
  height: calc(100% - 140px); /* header (68px) + input (72px) = 140px */

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(
      circle at 1px 1px,
      rgba(255, 255, 255, 0.15) 1px,
      transparent 0
    );
    background-size: 20px 20px;
    pointer-events: none;
    opacity: 0.5;
  }

  @media (max-width: 768px) {
    height: calc(100% - 132px); /* header (64px) + input (68px) = 132px */
    padding: 10px;
  }
`;

export const MessageBubble = styled.div`
  max-width: 70%;
  min-width: 80px;
  margin-bottom: 12px;
  padding: 12px 16px;
  border-radius: ${(props) =>
    props.isMe ? "18px 4px 18px 18px" : "4px 18px 18px 18px"};
  background: ${(props) =>
    props.isMe
      ? "linear-gradient(135deg, rgb(220, 248, 198), rgb(225 237 208))"
      : "#ffffff"};
  align-self: ${(props) => (props.isMe ? "flex-end" : "flex-start")};
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  word-break: break-word;
  line-height: 1.4;
  position: relative;
  border: 1px solid ${(props) =>
    props.isMe ? "rgba(37, 211, 102, 0.2)" : "rgba(0, 0, 0, 0.05)"};
  
  &:before {
    content: '';
    position: absolute;
    ${(props) => (props.isMe ? "right: -6px" : "left: -6px")};
    top: 12px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    ${(props) => 
      props.isMe 
        ? "border-left-color: #dcf8c6;" 
        : "border-right-color: #ffffff;"
    }
  }
  
  @media (max-width: 768px) {
    max-width: 85%;
    padding: 10px 14px;
  }
`;

export const MessageText = styled.div`
  font-size: 14px;
  max-width: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  gap: 8px;
  line-height: 1.4;

  span {
    line-height: 1.4;
  }

  img {
    border-radius: 12px;
    max-width: 250px;
    height: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  audio {
    margin-top: 8px;
    width: 100%;
    max-width: 250px;
    min-width: 250px;
    border-radius: 20px;
  }

  a {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;
    display: inline-block;
    word-break: break-all;
    max-width: 100%;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const MessageMeta = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 6px;
  font-size: 11px;
  color: #667781;
  gap: 6px;
  align-self: flex-end;
`;

export const MessageStatus = styled.span`
  display: flex;
  align-items: center;
  margin-left: 4px;
  font-size: 12px;
  color: ${(props) => {
    switch (props.status) {
      case "error":
        return "#ef5350";
      case "delivered":
        return "#4fc3f7";
      case "sent":
        return "#667781";
      default:
        return "#667781";
    }
  }};
`;

export const StickyInputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  position: absolute;
  bottom: 70px;
  left: 0;
  right: 0;
  z-index: 10;
  border-top: 1px solid #e9edef;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  height: 72px; /* Altura fixa para cálculos */

  @media (max-width: 768px) {
    padding: 12px 15px;
    height: 68px;
  }
`;

export const AudioPreview = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #e9edef;
  border-radius: 12px 12px 0 0;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);

  .audio-player {
    flex: 1;
  }

  .audio-duration {
    font-size: 12px;
    color: #54656f;
  }

  .audio-actions {
    display: flex;
    gap: 8px;
  }
`;

export const EmojiButton = styled.button`
  background: transparent;
  border: none;
  color: #54656f;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.3s ease;
  border-radius: 50%;
  height: 44px;
  width: 44px;

  &:hover {
    background: #f0f2f5;
    color: #25d366;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const MessageInput = styled.textarea`
  flex: 1;
  border: 2px solid #e9edef;
  border-radius: 20px;
  padding: 12px 16px;
  outline: none;
  resize: none;
  max-height: 120px;
  font-family: inherit;
  font-size: 15px;
  line-height: 1;
  background: #ffffff;
  transition: all 0.3s ease;

  &:focus {
    border-color: #25d366;
    box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
  }

  &::placeholder {
    color: #667781;
  }

  @media (max-width: 768px) {
    font-size: 13.5px; /* Prevent zoom on iOS */
    max-height: 50px;
  }
`;

export const SendButton = styled.button`
  background: ${(props) =>
    props.disabled ? "#e9edef" : "linear-gradient(135deg, #25d366, #128c7e)"};
  border: none;
  color: ${(props) => (props.disabled ? "#54656f" : "white")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-size: 16px;
  margin-left: 12px;
  padding: 12px;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: ${(props) =>
    props.disabled ? "none" : "0 2px 8px rgba(37, 211, 102, 0.3)"};

  &:hover:not(:disabled) {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }
`;

export const EmptyChat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 80px);
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  text-align: center;
  padding: 40px;
`;

export const EmptyIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
  opacity: 0.6;
`;

export const EmptyChatTitle = styled.h2`
  font-size: 32px;
  font-weight: 300;
  color: #41525d;
  margin-bottom: 12px;
`;

export const EmptyChatText = styled.div`
  font-size: 16px;
  color: #667781;
  line-height: 1.5;
  max-width: 400px;
`;

export const ErrorMessageContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #ef5350;
  margin-top: 4px;
`;

export const ErrorMessage = styled.span`
  margin-right: 8px;
`;

export const WaStoppedOrPaused = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 60px 40px;
  text-align: center;
  max-width: 500px;
`;


export const WarningBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #fff3cd, #ffeaa7);
  border: 1px solid #ffc107;
  border-radius: 12px;
  color: #856404;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.2);
  margin: 16px 20px;
  position: absolute;
  bottom: 70px;
  left: 0;
  right: 0;
  z-index: 10;
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    margin: 12px 15px;
    padding: 12px 16px;
    font-size: 13px;
  }

  &:before {
    content: "⚠️";
    margin-right: 8px;
    font-size: 16px;
  }
`;

/* BOT CONTROLS */

export const BotControlsWrapper = styled.div`
  .dropdown-toggle:after{
    content: '';
  }
`;